import { Dialog, Transition } from "@headlessui/react";
import { RxCross1 } from "react-icons/rx";
import { Fragment } from "react";

export default function Modal({ show, hide, children, className }) {
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="fixed z-50 inset-0 " onClose={hide}>
        <div className=" flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child>
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-25 0transition-opacity" />
          </Transition.Child>
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen "
            aria-hidden="true"
          >
            &#8203;
          </span>
          <div
            className={`${className} w-10/12  xs:w-full sm:w-7/12 border lg:w-5/12 inline-block align-top bg-white
            rounded-3xl py-8 xl:px-16 sm:px-14 px-8 text-left overflow-hidden shadow-xl
            transform transition-all sm:align-middle`}
          >
            <div className=" absolute top-6 right-6">
              <button
                type="button"
                className=" text-black text-xl hover:text-gray-500  border border-black rounded-full p-2"
                onClick={() => {
                  hide(false);
                }}
              >
                <span className="sr-only">Close</span>
                <RxCross1 />
              </button>
            </div>
            {children}
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
